import {
  AdminUser,
  Dashboard,
  Role,
  WebUsers,
  userManagement,
} from "../constant/imagePath";

export const sidebarData = [
  {
    name: "Dashboard",
    pagePath: "/dashboard",
    svg: Dashboard,
    permissionText: true,
  },
  {
    name: "User MGMT",
    prefixPath: "/user-management",
    svg: userManagement,
    submenu: [
      {
        name: "Web User List",
        pagePath: "/user-management/web-user-list",
        svg: WebUsers,
        permissionText: "web-user.list",
      },
      {
        name: "Admin User List",
        pagePath: "/user-management/admin-user-list",
        svg: AdminUser,
        permissionText: "admin-user.list",
      },
      {
        name: " Roles & Permissions",
        pagePath: "/user-management/user-Permissions",
        svg: Role,
        permissionText: "role.list",
      },
    ],
  },
  {
    name: "Website Data MGMT",
    pagePath: "/web-data-management",
    prefixPath: "/web-data-management",
    svg: Dashboard,
    submenu: [
      {
        name: "Mapping",
        prefixPath: "mapping",
        svg: Dashboard,
        submenu: [
          {
            name: "Player Careers",
            pagePath: "/web-data-management/mapping/player-careers",
            svg: Dashboard,
            permissionText: "player-career.list",
          },
          {
            name: "Event Achievements",
            pagePath: "/web-data-management/mapping/event-achievements",
            svg: Dashboard,
            permissionText: "event-participant.list",
          },
          {
            name: "BP-PG1: J&U",
            pagePath:
              "/web-data-management/mapping/base-product-product-group/jerseys",
            svg: Dashboard,
            permissionText: "product-group-base-product.view",
          },
          {
            name: "BP-PG2: TM",
            pagePath:
              "/web-data-management/mapping/base-product-product-group/team-merchandise",
            svg: Dashboard,
            permissionText: "product-group-base-product.view",
          },
          {
            name: "BP-PG3: OB",
            pagePath:
              "/web-data-management/mapping/base-product-product-group/match-balls",
            svg: Dashboard,
            permissionText: "product-group-base-product.view",
          },
          // {
          //   name: "TG-Team",
          //   pagePath: "/web-data-management/mapping/team-group-team",
          //   svg: Dashboard,
          //   permissionText: "team-group-team.view",
          // },
          // {
          //   name: "CG-Competition",
          //   pagePath:
          //     "/web-data-management/mapping/competition-group-competition",
          //   svg: Dashboard,
          //   permissionText: "competition-group-competition.view",
          // },
          {
            name: "Sport-PG-PC-Product",
            pagePath:
              "/web-data-management/mapping/sport-group-category-product",
            svg: Dashboard,
            permissionText: "sport-group-category-product.view",
          },
          {
            name: "Product-Gender-Size",
            pagePath: "/web-data-management/mapping/product-gender-size",
            svg: Dashboard,
            permissionText: "product-gender-size.view",
          },
          {
            name: "Product-Brand",
            pagePath: "/web-data-management/mapping/product-brand",
            svg: Dashboard,
            permissionText: "product-brand.view",
          },
          {
            name: "Product-Version",
            pagePath: "/web-data-management/mapping/product-version",
            svg: Dashboard,
            permissionText: "product-version.view",
          },
        ],
      },
      {
        name: "Master Data",
        prefixPath: "/master-data",
        svg: Dashboard,
        submenu: [
          {
            name: "Sports",
            pagePath: "/web-data-management/master-data/sports",
            svg: Dashboard,
            permissionText: "sport.view",
          },
          {
            name: "Team Groups",
            pagePath: "/web-data-management/master-data/team-groups",
            svg: Dashboard,
            permissionText: "team-group.view",
          },
          {
            name: "Teams",
            pagePath: "/web-data-management/master-data/teams",
            svg: Dashboard,
            permissionText: "team.view",
          },
          {
            name: "Player Types",
            pagePath: "/web-data-management/master-data/player-types/lists",
            svg: Dashboard,
            permissionText: "player-type.list",
          },
          {
            name: "Players",
            pagePath: "/web-data-management/master-data/players",
            svg: Dashboard,
            permissionText: "player.list",
          },
          {
            name: "Competition Groups",
            pagePath: "/web-data-management/master-data/competition-groups",
            svg: Dashboard,
            permissionText: "competition-group.view",
          },
          {
            name: "Competitions",
            pagePath: "/web-data-management/master-data/competitions",
            svg: Dashboard,
            permissionText: "competition.view",
          },
          {
            name: "Events",
            pagePath: "/web-data-management/master-data/events",
            svg: Dashboard,
            permissionText: "event.view",
          },
          {
            name: "Product Groups",
            pagePath: "/web-data-management/master-data/product-groups",
            svg: Dashboard,
            permissionText: "product-group.view",
          },
          {
            name: "Product Categories",
            pagePath: "/web-data-management/master-data/product-categories",
            svg: Dashboard,
            permissionText: "product-category.view",
          },
          {
            name: "Product Classes",
            pagePath: "/web-data-management/master-data/product-classes",
            svg: Dashboard,
            permissionText: "product-class.view",
          },
          {
            name: "Products",
            pagePath: "/web-data-management/master-data/products",
            svg: Dashboard,
            permissionText: "product.view",
          },
          {
            name: "Brands",
            pagePath: "/web-data-management/master-data/brands",
            svg: Dashboard,
            permissionText: "brand.view",
          },
          {
            name: "Conditions",
            pagePath: "/web-data-management/master-data/conditions",
            svg: Dashboard,
            permissionText: "condition.view",
          },
          {
            name: "Editions",
            pagePath: "/web-data-management/master-data/editions",
            svg: Dashboard,
            permissionText: "edition.view",
          },
          {
            name: "Genders",
            pagePath: "/web-data-management/master-data/genders",
            svg: Dashboard,
            permissionText: "gender.view",
          },
          {
            name: "Materials",
            pagePath: "/web-data-management/master-data/materials",
            svg: Dashboard,
            permissionText: "material.view",
          },
          {
            name: "Sizes",
            pagePath: "/web-data-management/master-data/product-sizes",
            svg: Dashboard,
            permissionText: "product-size.view",
          },
          {
            name: "Terms",
            pagePath: "/web-data-management/master-data/terms",
            svg: Dashboard,
            permissionText: "term.view",
          },
          {
            name: "Versions",
            pagePath: "/web-data-management/master-data/versions",
            svg: Dashboard,
            permissionText: "version.view",
          },
        ],
      },
    ],
  },
  {
    name: "Finance MGMT",
    prefixPath: "/finance-management",
    svg: Dashboard,
    submenu: [
      {
        name: "Platform Fees",
        pagePath: "/finance-management/platform-fees",
        svg: Dashboard,
        permissionText: "platform-fee.view",
      },
      {
        name: "Sales Report",
        pagePath: "/finance-management/sales-report",
        svg: Dashboard,
        permissionText: "sales-report.list",
      },
    ],
  },
  {
    name: "Transaction MGMT",
    pagePath: "/transaction-management",
    svg: Dashboard,
    permissionText: "supported-country.list",
  },
  {
    name: "Review MGMT",
    pagePath: "/review-management",
    svg: Dashboard,
    permissionText: "supported-country.list",
  },
  {
    name: "Currency MGMT",
    prefixPath: "/currency-management",
    svg: Dashboard,
    submenu: [
      {
        name: "Platform Currencies",
        pagePath: "/currency-management/platform-currencies",
        svg: Dashboard,
        permissionText: "currency.list",
      },
      {
        name: "FX Rates",
        pagePath: "/currency-management/fx-rates",
        svg: Dashboard,
        permissionText: "currency-rate.list",
      },
    ],
  },
  {
    name: "Language MGMT",
    prefixPath: "/language-management",
    svg: Dashboard,
    submenu: [
      {
        name: "Platform Languages",
        pagePath: "/language-management/platform-languages",
        svg: Dashboard,
        permissionText: "language.list",
      },
      {
        name: "Translations Static",
        pagePath: "/language-management/translations-static",
        svg: Dashboard,
        permissionText: "translation.list",
      },
    ],
  },
  {
    name: "Country MGMT",
    pagePath: "/country-management",
    svg: Dashboard,
    permissionText: "supported-country.list",
  },
  {
    name: "Shipping MGMT",
    prefixPath: "/shipping-management",
    svg: Dashboard,
    submenu: [
      {
        name: "Matrix - Standard",
        pagePath: "/shipping-management/matrix-standard",
        svg: Dashboard,
        permissionText: "matrix-standard.list",
      },
      {
        name: "Matrix - Express",
        pagePath: "/shipping-management/matrix-express",
        svg: Dashboard,
        permissionText: "matrix-express.list",
      },
    ],
  },
  {
    name: "Content MGMT",
    prefixPath: "/content-management",
    permissionText: "content-management.list",
    svg: Dashboard,
    submenu: [
      {
        name: "Banners",
        pagePath: "/content-management/banners",
        svg: Dashboard,
        permissionText: "banner.list",
      },
      {
        name: "Backgrounds",
        pagePath: "/content-management/backgrounds",
        svg: Dashboard,
        permissionText: "background.list",
      },
      {
        name: "Announcements",
        pagePath: "/content-management/announcements",
        svg: Dashboard,
        permissionText: "announcement.list",
      },
    ],
  },
  {
    name: "Blog MGMT",
    prefixPath: "/blog-management",
    svg: Dashboard,
    submenu: [
      {
        name: "Blog Categories",
        pagePath: "/blog-management/blog-categories",
        svg: Dashboard,
        permissionText: "blog-category.list",
      },
      {
        name: "Blog Posts",
        pagePath: "/blog-management/blog-posts",
        svg: Dashboard,
        permissionText: "blog-post.list",
      },
    ],
  },
  {
    name: "JM Interactive MGMT",
    prefixPath: "/jm-interactive-mgmt",
    permissionText: "content-management.list",
    svg: Dashboard,
    submenu: [
      {
        name: "Achievement Badges",
        pagePath: "/jm-interactive-mgmt/achievement-badges",
        svg: Dashboard,
        permissionText: "achievement-badge.list",
      },
      {
        name: "Videos",
        pagePath: "/jm-interactive-mgmt/videos",
        svg: Dashboard,
        submenu: [
          {
            name: "Videos Posted",
            pagePath: "/jm-interactive-mgmt/videos/video-posted",
            svg: Dashboard,
            permissionText: "video-wall.list",
          },
          {
            name: "Video Categories",
            pagePath: "/jm-interactive-mgmt/videos/video-categories",
            svg: Dashboard,
            permissionText: "video-category.list",
          },
        ],
      },
      {
        name: "Pictures",
        pagePath: "/jm-interactive-mgmt/pictures",
        svg: Dashboard,
        submenu: [
          {
            name: "Pictures Posted",
            pagePath: "/jm-interactive-mgmt/pictures/picture-posted",
            svg: Dashboard,
            permissionText: "picture.list",
          },
          {
            name: "Picture Categories",
            pagePath: "/jm-interactive-mgmt/pictures/picture-categories",
            svg: Dashboard,
            permissionText: "picture-category.list",
          },
        ],
      },
    ],
  },
  {
    name: "Communication MGMT",
    prefixPath: "/communication-management",
    svg: Dashboard,
    submenu: [
      {
        name: "Support Tickets",
        pagePath: "/communication-management/support-tickets",
        showBadge: true,
        badgeKey: "all_support_tickets",
        svg: Dashboard,
        permissionText: "contact-support.list",
      },
      {
        name: "My Tickets",
        pagePath: "/communication-management/my-tickets",
        showBadge: true,
        badgeKey: "my_tickets",
        svg: Dashboard,
        permissionText: "contact-support.list",
      },
    ],
  },
  {
    name: "Setting MGMT",
    pagePath: "/settings",
    svg: Dashboard,
    permissionText: "setting.view",
  },
  {
    name: "Audit Logs",
    pagePath: "/audit-logs",
    svg: Dashboard,
    permissionText: "audit-log.list",
  },
  {
    name: "Transactions MGMT",
    pagePath: "/Transactions-Management",
    svg: Dashboard,
  },
  {
    name: "Communications MGMT",
    pagePath: "/Communications-Management",
    svg: Dashboard,
  },
  {
    name: "Financial MGMT",
    pagePath: "/Financial-Management",
    svg: Dashboard,
  },
  {
    name: "Language MGMT",
    pagePath: "/Language-Management",
    svg: Dashboard,
  },
  {
    name: "Country MGMT",
    pagePath: "/Country-Management",
    svg: Dashboard,
  },
  {
    name: "Shipping MGMT",
    pagePath: "/Shipping-Management",
    svg: Dashboard,
  },
  {
    name: "Content MGMT",
    pagePath: "/Content-Management",
    svg: Dashboard,
  },
  {
    name: "JM Interactive MGMT",
    pagePath: "/JM-Interactive-Management",
    svg: Dashboard,
  },
  {
    name: "Profiles",
    pagePath: "/profile",
    svg: Dashboard,
  },
  {
    name: "Text Label",
    pagePath: "/Text-Label",
    svg: Dashboard,
  },
  {
    name: "eBay API",
    pagePath: "/eBay-API",
    svg: Dashboard,
  },
  {
    name: "Jersium API",
    pagePath: "/Jersium-API",
    svg: Dashboard,
  },
  {
    name: "My Admin Account",
    pagePath: "/My-Admin-Account",
    svg: Dashboard,
  },
  {
    name: "eBay API",
    pagePath: "/eBay-API",
    svg: Dashboard,
  },
  {
    name: "Jersium API",
    pagePath: "/Jersium-API",
    svg: Dashboard,
  },
  {
    name: "My Admin Account",
    pagePath: "/My-Admin-Account",
    svg: Dashboard,
  },
];

export const FILTER_DATA = [
  {
    label: "Has Sales PY",
    list: [
      { title: "Any", pagePath: "any" },
      { title: "Yes", pagePath: "yes" },
      { title: "No", pagePath: "no" },
    ],
  },
  {
    label: "Has Sales YTD",
    list: [
      { title: "Any", pagePath: "any" },
      { title: "Yes", pagePath: "yes" },
      { title: "No", pagePath: "no" },
    ],
  },
];

export const mainAdminPermissions = [
  "admin-user.list",
  "admin-user.create",
  "admin-user.edit",
  "admin-user.delete",
  "admin-user.restrict",
  "role.list",
  "role.create",
  "role.edit",
  "role.delete",
];

export const routeNotVisitable = [
  // "/user-management",
  // "/web-data-management",
  // "/user-management/web-user-detail",
];
